var exports = {
  "fs": "SpaceBackground.module__starfield___Ykhwc0",
  "UB": "SpaceBackground.module__starDrift___Ykhwc0",
  "hi": "SpaceBackground.module__spaceBackground___Ykhwc0" + " " + "SpaceBackground.module__starfield___Ykhwc0",
};

module.exports = exports;
